<template>
    <div class="appwrap">
      <div  uk-sticky="" class="nav-wrapper">
        <TopNav />
        <ListingBar v-bind:views="views" />
        <GiftCardBar v-bind:views="views" />
      </div>
        <slot />
        <BottomNav />
        <OffCanvasMenu />
      <div ref="offcanvas"></div>
      <div id="ss-modal-center" class="uk-flex-top" uk-modal>`
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <div id="stamp-title">{{ $t("StampTheScreen") }}</div>
          <div @touchstart="onTouchStartStamp" @touchstart.native="onTouchStartStamp"
               id="stamp-area">
            <div id="stamp-general-modal-img" :style="{ 'backgroundImage': 'url(\'' + bgImg + '\')' }"></div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import TopNav from '../components/TopNav.vue'
import ListingBar from '../components/ListingNavBar'
import GiftCardBar from '../components/GiftCardNavBar'
import BottomNav from '../components/BottomNav'
import OffCanvasMenu from '../components/OffCanvasMenu'
// import SnowShoeStamp from '../components/SnowShoeStamp'

const searchBarDefault = true
const listingBarDefault = false
export default {
  data () {
    return {
      views: 'list',
      bgImg: require('../assets/images/stamp/stamp_hands_black.png')
    }
  },
  computed: {
    searchBar () {
      if (this.$route.meta.searchbar !== '') {
        return this.$route.meta.searchbar
      } else {
        return searchBarDefault
      }
    },
    listingBar () {
      if (this.$route.meta.listingbar !== '') {
        return this.$route.meta.listingbar
      } else {
        return listingBarDefault
      }
    }
  },
  components: {
    TopNav,
    ListingBar,
    GiftCardBar,
    BottomNav,
    OffCanvasMenu
    // SnowShoeStamp

  }
}
</script>
<style scoped lang="less">
  .uk-modal-body{
    padding: 0 !important;
  }
  #stamp-area{
    height: 75vh;
  }
  #stamp-title{
    text-align: center;
    font-size: 1.7em;
    padding: 30px 0 0 10px;
  }
  #stamp-general-modal-img {
    background-position: top;
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/Default.vue